'use client';

import { useLayoutEffect } from 'react';
import { usePathname } from 'next/navigation';

import { useGlobalTracker } from '@/hooks';
import { onH5PathnameChange, reportH5ColdLoadPerf, scheduleH5SpaRoutePerf } from '@/utils/performance-log';
import { getTrackerSpaReferrerPathname, syncTrackerRoute } from '@/utils/tracker';
import { logPageExposureTrack } from '@/utils/tracker/global-info';

/**
 * 根布局全局埋点副作用组件
 *
 * @description
 * 须在 RootProvider 内挂载一次，且处于 Next 路由上下文（usePathname）中：
 * - 路由 pathname 同步与页面曝光（PAGE_EXPOSURE）
 * - H5 冷启 / SPA 路由加载性能（见 @/utils/performance-log）
 * - H5 整页冷启标记（任意 pathname 变更，供 reader_perf 等使用）
 * - 系统首次访问（localStorage）与回前台首次交互（sessionStorage）H5_OPEN（见 useGlobalTracker）
 *
 * 使用方式：
 *   <RootProvider>
 *     <GlobalTrackerSync />
 *     {children}
 *   </RootProvider>
 */
export default function GlobalTrackerSync() {
    const pathname = usePathname();

    // 系统首次访问与切后台回前台后的首次交互 H5_OPEN
    useGlobalTracker();

    // pathname 变更时同步 SPA 路由上下文；layout 阶段上报曝光，早于子树 paint
    useLayoutEffect(() => {
        const fromPathname = getTrackerSpaReferrerPathname();
        const isColdDocumentEntry = onH5PathnameChange();

        if (isColdDocumentEntry) {
            reportH5ColdLoadPerf(pathname);
        } else {
            scheduleH5SpaRoutePerf({ toPathname: pathname, fromPathname });
        }

        syncTrackerRoute(pathname);
        logPageExposureTrack();
    }, [pathname]);

    return null;
}
